import { useTranslation } from 'react-i18next';
import { signOut } from '../lib/auth/signOut';
import { ThemeToggle } from '../theme/ThemeToggle';

/**
 * Sidebar bottom — theme switch + sign out only (profile lives in the header).
 */
export function SidebarFooter() {
  const { t } = useTranslation();

  return (
    <div
      className="mt-auto flex shrink-0 flex-col gap-2 border-t px-3.5 py-3"
      style={{ borderColor: 'var(--gs-line)' }}
    >
      <ThemeToggle />

      <button
        type="button"
        onClick={() => void signOut()}
        className="rounded-[10px] px-3 py-2 text-start text-[13.5px] font-semibold transition-colors hover:text-[var(--gs-accent)]"
        style={{
          color: 'var(--gs-ink2)',
          background: 'transparent',
          border: 'none',
          fontFamily: 'inherit',
          cursor: 'pointer',
        }}
      >
        {t('actions.signOut')}
      </button>
    </div>
  );
}
